import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import ListItem from "@material-ui/core/ListItem";
import Skeleton from "@material-ui/lab/Skeleton";

import EditIcon from "@material-ui/icons/Edit";
import FacebookIcon from "@material-ui/icons/Facebook";
import InstagramIcon from "@material-ui/icons/Instagram";
import TwitterIcon from "@material-ui/icons/Twitter";
import YouTubeIcon from "@material-ui/icons/YouTube";

import { useStyles } from "./InforDetails.css";
import { publicImageUrl } from "../../../../Config/publicImageUrl";

class InfoDetails extends Component {
  render() {
    const { classes, data, handleEdit } = this.props;
    return (
      <div className={classes.root}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={4} xl={4} lg={4}>
            <Paper className={classes.paper}>
              <div style={{ fontSize: 20 }}>{data.schoolName}</div>
              {data.schoolLogo ? (
                <img
                  src={`${publicImageUrl}/${data.schoolLogo}`}
                  alt={data.schoolName}
                  style={{ width: 200, height: 200 }}
                />
              ) : (
                <Skeleton
                  variant="circle"
                  style={{ width: 150, height: 150 }}
                />
              )}
              <div style={{ paddingTop: 10 }}>
                <Tooltip
                  arrow
                  title={`${data.fbLink ? "Facebook" : "N/A"}`}
                  className={classes.tooltip}
                >
                  <FacebookIcon
                    style={{ color: data.fbLink ? "#004f71" : "#636363" }}
                  />
                </Tooltip>
                <Tooltip
                  arrow
                  title={`${data.instaLink ? "Instagram" : "N/A"}`}
                  className={classes.tooltip}
                >
                  <InstagramIcon
                    style={{ color: data.instaLink ? "#004f71" : "#636363" }}
                  />
                </Tooltip>
                <Tooltip
                  arrow
                  title={`${data.twitterLink ? "Twitter" : "N/A"}`}
                  className={classes.tooltip}
                >
                  <TwitterIcon
                    style={{ color: data.twitterLink ? "#004f71" : "#636363" }}
                  />
                </Tooltip>
                <Tooltip
                  arrow
                  title={`${data.youtubeLink ? "YouTube" : "N/A"}`}
                  className={classes.tooltip}
                >
                  <YouTubeIcon
                    style={{ color: data.youtubeLink ? "#004f71" : "#636363" }}
                  />
                </Tooltip>
              </div>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={12} md={8} xl={8} lg={8}>
            <div className={classes.title}>
              <div style={{ fontSize: 20 }}>School Information</div>
              <Tooltip
                arrow
                title="Edit"
                className={classes.tooltip}
                onClick={() => handleEdit(true)}
              >
                <EditIcon />
              </Tooltip>
            </div>
            <ListItem divider className={classes.listitemDetails}>
              <b style={{ flexGrow: 1 }}>School Full Name</b>
              <div>{data.schoolName}</div>
            </ListItem>
            <div className={classes.listitemContent}>
              <ListItem divider className={classes.listitemDetails}>
                <b style={{ flexGrow: 1 }}>Abbreviation Name</b>
                <div>{data.shortName}</div>
              </ListItem>
              <ListItem divider className={classes.listitemDetails}>
                <b style={{ flexGrow: 1 }}>School Address</b>
                <div>{data.address}</div>
              </ListItem>
            </div>
            <div className={classes.listitemContent}>
              <ListItem divider className={classes.listitemDetails}>
                <b style={{ flexGrow: 1 }}>Landline Number</b>
                <div>{data.landLineNumber}</div>
              </ListItem>
              <ListItem divider className={classes.listitemDetails}>
                <b style={{ flexGrow: 1 }}>Alternate Landline Number</b>
                <div>
                  {data.altLandLineNumber ? data.altLandLineNumber : "N/A"}
                </div>
              </ListItem>
            </div>
            <div className={classes.listitemContent}>
              <ListItem divider className={classes.listitemDetails}>
                <b style={{ flexGrow: 1 }}>Mobile Number</b>
                <div>{data.mobileNumber}</div>
              </ListItem>
              <ListItem divider className={classes.listitemDetails}>
                <b style={{ flexGrow: 1 }}>Alternate Mobile Number</b>
                <div>{data.altMobileNumber ? data.altMobileNumber : "N/A"}</div>
              </ListItem>
            </div>
            <div className={classes.listitemContent}>
              <ListItem divider className={classes.listitemDetails}>
                <b style={{ flexGrow: 1 }}>Email Address</b>
                <div>{data.email}</div>
              </ListItem>
              <ListItem divider className={classes.listitemDetails}>
                <b style={{ flexGrow: 1 }}>Alternate Email Address</b>
                <div>{data.altEmail ? data.altEmail : "N/A"}</div>
              </ListItem>
            </div>
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default withStyles(useStyles)(InfoDetails);
